import { call, put, takeLatest } from 'redux-saga/effects';
import { getInternalMetrics, getUsers, getMetricsByOrganization } from 'api/InternalAdminAPI';
import { addToRootSaga } from 'store';
import * as actions from './actions';
import * as actionTypes from './actionTypes';

export function* fetchInternalMetrics() {
  try {
    const response = yield call(getInternalMetrics);
    yield put(actions.receivedInternalMetrics(response.data));
  } catch (error) {
    yield put(actions.fetchInternalMetricsError(error));
  }
}

export function* fetchUsers() {
  try {
    const response = yield call(getUsers);
    yield put(actions.receivedUsers(response.data));
  } catch (error) {
    yield put(actions.fetchUsersError(error));
  }
}

export function* fetchMetricsByOrganization({ data }) {
  try {
    const response = yield call(getMetricsByOrganization, data);
    yield put(actions.receivedOrganizationMetrics(response.data));
  } catch (error) {
    yield put(actions.fetchMetricsByOrganizationError(error));
  }
}

addToRootSaga([
  takeLatest(actionTypes.FETCH_INTERNAL_METRICS_REQUEST, fetchInternalMetrics),
  takeLatest(actionTypes.FETCH_USERS_REQUEST, fetchUsers),
  takeLatest(actionTypes.FETCH_METRICS_BY_ORGANIZATION_REQUEST, fetchMetricsByOrganization),
]);
